import { ChangeDetectionStrategy, Component, ContentChild, HostListener } from '@angular/core';
import { ControlPageCardExpandComponent } from '@pages/control-page/components/control-page-card-expand/control-page-card-expand.component';

@Component({
  selector: 'app-control-page-card-header',
  templateUrl: './control-page-card-header.component.html',
  styleUrl: './control-page-card-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ControlPageCardHeaderComponent {

  @ContentChild(ControlPageCardExpandComponent) expand: ControlPageCardExpandComponent;

  @HostListener('click', ['$event'])
  click(event) {
    event.stopPropagation();
    this.expand.toggle();
  }

}
